import { render } from "./FooterCom.vue?vue&type=template&id=085aedb0&scoped=true"
const script = {}

import "./FooterCom.vue?vue&type=style&index=0&id=085aedb0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085aedb0"]])

export default __exports__